import HttpClient from './clients/httpClient';
import Auth from './auth';
import StoreManager from './storeManagerRepository';

export const AuthRepository = Auth(HttpClient);
export const StoreManagerRepository = StoreManager(HttpClient);